import { Injectable } from "@angular/core";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

@Injectable({
  providedIn: 'root'
})
export class Logger {
  private ai: ApplicationInsights;

  constructor() {
    this.ai = new ApplicationInsights({
      config: {
        instrumentationKey: 'b0aa9087-62e4-432b-8b11-df1d371ba5ae',
        // Disable deprecated unload event (use pagehide instead) to allow bfcache
        disablePageUnloadEvents: ['unload'],
      }
    });

    this.ai.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    this.ai.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any; }) {
    this.ai.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any; }) {
    this.ai.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.ai.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any; }) {
    this.ai.trackTrace({ message: message }, properties);
  }
}
